"use client";

import styles from "./styles.module.css";
import ContactForm from "@components/molecules/ContactForm";
import config from "config/all-config.json";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { SnackbarProvider } from "notistack";

export default function ContactSection() {
  const t = useTranslations("contact.contactDetails");

  return (
    <section className="flex flex-col items-center">
      <div className={styles["detail-wrapper"]}>
        {config.contact.contactDetails.map((item, key) => {
          return (
            <div key={key} className={styles["detail-box"]}>
              <Image
                src={`/${item.icon}`}
                width={item.width}
                height={item.height}
                alt={item.alt}
                title={item.imageTitle}
              />
              <a href={t(`${key}.linkText`)}>{t(`${key}.text`)}</a>
              {item.additionalText && <a href={t(`${key}.linkAdditionalText`)}>{t(`${key}.additionalText`)}</a>}
            </div>
          );
        })}
      </div>

      <GoogleReCaptchaProvider
        reCaptchaKey={process.env.NEXT_PUBLIC_GOOGLE_CAPTCHA_KEY || ""}
        scriptProps={{
          async: false, // optional, default to false,
          defer: false, // optional, default to false
          appendTo: "head", // optional, default to "head", can be "head" or "body",
          nonce: undefined, // optional, default undefined
        }}
      >
        <SnackbarProvider>
          <ContactForm />
        </SnackbarProvider>
      </GoogleReCaptchaProvider>

      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11386.510128429321!2d26.0905905!3d44.481807!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b203efc6558ecd%3A0x160c1aa59e1dde68!2sWebitLabs!5e0!3m2!1sen!2sro!4v1691065957026!5m2!1sen!2sro"
        width="100"
        height="650"
        className="relative bottom-[-87px] md:bottom-[-64px] w-full"
        style={{ border: 0, zIndex: 2, filter: "invert(100%)" }}
        allowFullScreen={true}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Google Maps"
      ></iframe>
    </section>
  );
}
